export default {
  loadingProfile: "Cargando perfil...",
  errorLoadingProfile: "Error al cargar el perfil",
  profileChangedTo: "Perfil cambiado a {{type}}",
  sectionSaved: "Sección guardada correctamente",
  saveSection: "Guardar sección",
  revertSection: "Revertir",
  checkHighlighted: "Revise los campos resaltados",
  pageTitle: "Ajustes",
  sectionsNav: "Secciones",
  profileDescription: "Gestione su perfil, contacto y datos de pago",
  confirmChangeTitle: "¿Cambiar el tipo de perfil?",
  confirmChangeMessage:
    "Al cambiar de «{{from}}» a «{{to}}» se borrarán los campos específicos del perfil {{dataType}} (nombre, fecha de nacimiento o datos de empresa). Dirección, contacto, documento y pago se conservan.",
  individual: "Persona física",
  company: "Empresa",
  confirmChange: "Sí, cambiar tipo",
  adminPageTitle: "Ajustes",
  adminPageDescription: "Gestione su cuenta",
  adminCardTitle: "Perfil de staff",
  adminBadge: "Staff",
  taxValidation: {
    vatNotFound: "NIF-IVA no encontrado en el registro.",
    vatMatched: "{{name}} · {{address}}",
    fiscalCodeInvalid: "NIF no válido.",
  },
  forms: {
    region: {
      cardTitle: "Región de pago",
      hint: "Se asigna al crear la cuenta y no se puede cambiar.",
    },
    profileType: {
      cardTitle: "Tipo de perfil",
      individualTitle: "Persona física",
      individualDesc: "Particular",
      businessTitle: "Empresa",
      businessDesc: "Sociedad u organización",
    },
    profileStatus: {
      completeTitle: "Perfil completo",
      incompleteTitle: "Perfil incompleto",
      incompleteDesc:
        "Complete todos los campos obligatorios para activar su cuenta",
    },
    person: {
      cardPersonal: "Datos personales",
      firstName: "Nombre",
      lastName: "Apellidos",
      birthDate: "Fecha de nacimiento",
      birthPlace: "Lugar de nacimiento",
      birthPlacePh: "Ciudad, país",
      idAsShown: "Como en el documento",
      fiscalCode: "NIF / identificación fiscal",
      fiscalCodePh: "Su número de identificación fiscal",
      cardResidence: "Domicilio",
      cardIdentity: "Documento de identidad",
    },
    company: {
      cardBusiness: "Datos de la empresa",
      companyName: "Razón social",
      companyNamePh: "Acme S.L.",
      vatNumber: "NIF-IVA",
      vatNumberPh: "XX123456789",
      taxId: "Identificación fiscal",
      taxIdPh: "Identificación fiscal de la empresa",
      cardRegistered: "Domicilio social",
      cardLegalRep: "Representante legal",
      fullName: "Nombre completo",
      fullNamePh: "Juan García",
    },
    address: {
      street: "Dirección",
      streetPh: "Calle Mayor 1",
      postalCode: "Código postal",
      postalPh: "28001",
      city: "Ciudad",
      cityPh: "Madrid",
      state: "Provincia / región",
      statePh: "Madrid",
      country: "País",
      countryPh: "España",
    },
    document: {
      type: "Tipo de documento",
      typePh: "DNI, pasaporte...",
      number: "Número",
      numberPh: "AB1234567",
      issuer: "Autoridad emisora",
      issuerPh: "Oficina competente",
      issueDate: "Fecha de expedición",
      expiryDate: "Fecha de caducidad",
    },
    contact: {
      cardTitle: "Datos de contacto",
      phone: "Teléfono",
      phonePlaceholder: "+34 612 345 678",
      phoneHint:
        "Escribe el prefijo internacional (p. ej. +34) o elige un país; la bandera se actualiza sola.",
      email: "Correo electrónico",
      emailPh: "correo@ejemplo.com",
      emailHint:
        "Tras guardar, verifica con el enlace que te enviamos por correo — no hace falta un código.",
      pec: "Correo certificado (PEC)",
      pecPh: "nombre@pec.com",
      pecHint: "Para facturación electrónica",
      verified: "Verificado",
      resendCode: "Reenviar código",
      resendLink: "Reenviar enlace",
      verifySaveFirst: "Guarda los cambios y luego verifica.",
      confirmCode: "Confirmar",
      sendSmsCode: "Enviar código SMS",
      sendEmailLink: "Enviar correo de verificación",
      enterSmsCode: "Introduce el código de 6 dígitos que te acabamos de enviar por SMS.",
      otpAriaLabel: "Código de verificación SMS",
      verifyPhoneSent: "SMS enviado — introduce el código abajo.",
      verifyEmailSent:
        "Te enviamos un enlace de verificación. Abre el correo y haz clic (también desde el móvil) — no hace falta un código. Esta página se actualiza sola.",
      verifyEmailWaiting:
        "Esperando a que hagas clic en el enlace del correo…",
      verifyPhoneSuccess: "Teléfono verificado.",
      verifyEmailSuccess: "Correo verificado.",
      verifyPhoneLimit: "Límite de SMS alcanzado. Inténtalo más tarde.",
      verifyEmailLimit: "Límite de correo alcanzado. Inténtalo más tarde.",
      verifyConfirmLimit: "Demasiados intentos. Inténtalo más tarde.",
      verifyPhoneNotSmsCapable: "Este número no puede recibir SMS.",
      verifyCodeInvalid: "Código no válido o caducado.",
      notificationChannel: "Notificaciones de reservas",
      notificationChannelHint:
        "Elige dónde recibir avisos de nuevas reservas, mensajes y cancelaciones.",
      notificationChannelWhatsApp: "WhatsApp",
      notificationChannelEmail: "Correo electrónico",
      notificationLanguage: "Idioma de las notificaciones",
    },
    payment: {
      cardTitle: "Datos de pago",
      iban: "IBAN",
      ibanOptional: "IBAN",
      ibanPh: "XX00 0000 0000 0000 0000 00",
      ibanHint: "15-34 caracteres",
      accountHolder: "Titular de la cuenta",
      accountHolderOptional: "Titular de la cuenta",
      accountHolderPh: "Juan García o Acme S.L.",
      accountHolderHint: "Al menos 3 caracteres",
    },
  },
} as const;
